import { ProcessedArticleBody } from "@typings/Opensearch";

import GetLimitedParagraphsFromArticleBody from "../GetLimitedParagraphsFromArticleBody";

export function useParagraphsToRender(
  isInfiniteScroll: boolean,
  showFull: boolean,
  paragraphs: ProcessedArticleBody | null,
  limit = 3,
) {
  if (!paragraphs) return null;
  return isInfiniteScroll && !showFull
    ? GetLimitedParagraphsFromArticleBody(paragraphs, limit)
    : paragraphs;
}
